import React from "react";
import { MdVerified } from "react-icons/md";

const VerifiedAccount = ({ verified, size, style }) => {
  return verified ? (
    <div
      style={{
        display: "inline-block",
        height: size,
        width: size,
        verticalAlign: "text-top",
        ...style,
      }}
    >
      <MdVerified size={size} color="#782dc8" />
    </div>
  ) : null;
};

export default VerifiedAccount;
